const domain = "https://wlmvp-cos.weiling.cn";
// 快照模式提示框背景图
export const snapshot_notice_bg =
  domain + "/frontend%2FweilingMobileUI%2Fsnapshot-user-notice-bg.png";
